// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD07EZp81-FdVrAl9hq2ihEfoNBn2YZD8Q",
  authDomain: "bhh-healthexpo.firebaseapp.com",
  projectId: "bhh-healthexpo",
  storageBucket: "bhh-healthexpo.appspot.com",
  messagingSenderId: "409610393139",
  appId: "1:409610393139:web:05b4cfb4b25ba8eadc7546",
  measurementId: "G-7WGYQDDPSD",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)